import { render } from "./DeviceManagement.vue?vue&type=template&id=256b47e2&scoped=true"
import script from "./DeviceManagement.vue?vue&type=script&lang=js"
export * from "./DeviceManagement.vue?vue&type=script&lang=js"

import "./DeviceManagement.vue?vue&type=style&index=0&id=256b47e2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-256b47e2"]])

export default __exports__